var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"dropdown-item d-flex align-items-center justify-content-between",on:{"click":_vm.signout}},[_c('span',{staticClass:"me-2"},[_vm._v("Log out")]),_c('i',{staticClass:"fa-solid fa-arrow-right-from-bracket text-muted"})])
}
var staticRenderFns = []

export { render, staticRenderFns }